import React from "react";
import PropTypes from "prop-types";
import styles from "./Interests.css";

const Interests = ({ interests }) => (
  <div className={styles.Interests}>
    <div className={styles.InterestsHeader}>
      <h2>Interests</h2>
      <p>{interests.join(", ")}</p>
    </div>
  </div>
);

Interests.propTypes = {
  interests: PropTypes.instanceOf(Array).isRequired
};

export default Interests;



// WEBPACK FOOTER //
// ./src/containers/ResumeBox/Resume/Interests/Interests.js